import React from "react";
import { Link } from "react-router-dom";
import whatsNewBanner from "../../assets/img/whatsNewBanner.jpg";

export default function English() {
	return (
		<>
			{/* ===== EMBEDDED CSS ===== */}
			<style>{`
        .hafele-cup-section {
          font-family: 'Segoe UI', Arial, sans-serif;
          background-color: #f5f5f7;
          min-height: 100vh;
          padding-top: 20px;
        }
        
        .app-header {
          background: #c40000;
          color: white;
          padding: 16px;
          text-align: center;
          font-size: 18px;
          font-weight: 600;
          position: sticky;
          top: 0;
        }
        
        .app-container {
          max-width: 480px;
          margin: auto;
          padding: 16px;
        }
        
        .card-custom {
          background: white;
          border-radius: 16px;
          padding: 18px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          margin-bottom: 20px;
          border: none;
        }
        
        .banner {
          width: 100%;
          border-radius: 12px;
          margin-bottom: 15px;
          object-fit: cover;
        }
        
        .title {
          font-size: 16px;
          font-weight: 600;
          color: #c40000;
          margin-bottom: 8px;
        }
        
        .section-title {
          font-size: 15px;
          font-weight: 600;
          margin-top: 20px;
          margin-bottom: 8px;
          color: #333;
          border-left: 4px solid #c40000;
          padding-left: 8px;
        }
        
        .card-custom p {
          font-size: 14px;
          line-height: 1.6;
          color: #555;
          margin-bottom: 10px;
        }
        
        .card-custom ul {
          padding-left: 18px;
          margin-bottom: 10px;
        }
        
        .card-custom ul li {
          font-size: 14px;
          margin-bottom: 6px;
          color: #444;
        }
        
        .highlight {
          background: #fff5f5;
          padding: 12px;
          border-radius: 10px;
          font-size: 13px;
          margin-top: 10px;
          border: 1px solid #ffd6d6;
          color: #555;
        }
        
        .bottom-space {
          height: 40px;
        }
      `}</style>

			{/* ===== APP CONTENT ===== */}
			<section className="hafele-cup-section">
				<div className="app-container">
					<div className="card-custom">
						<img
							src={whatsNewBanner}
							alt="Hafele CUP Banner"
							className="banner"
						/>

						<div className="title">
							Hafele Contractor Unnati Programme (CUP)
						</div>

						<p>
							A dedicated loyalty and engagement platform created by Hafele India to appreciate, empower, and reward independent trade professionals including contractors and carpenters.
						</p>

						{/* <div className="section-title">About the Programme</div>
						<p>
							The initiative strengthens Hafele’s relationship with professionals who guide customer decisions regarding hardware, fittings, and home solutions.
						</p> */}

						{/* <div className="section-title">Programme Objectives</div>
						<ul>
							<li>Increase product awareness and recommendations.</li>
							<li>Build strong brand advocacy.</li>
							<li>Reward trade partner contributions.</li>
						</ul> */}

						<div className="section-title">How It Works</div>
						<ul>
							<li>Purchase eligible Hafele products with QR codes.</li>
							<li>Scan using the CUP mobile app.</li>
							<li>Earn reward points instantly.</li>
						</ul>

						<div className="highlight">
							Points vary by product category and scan frequency. Stay updated on new launches and exclusive schemes.
						</div>

						<div className="section-title">Rewards & Benefits</div>
						<ul>
							<li>Bank Transfer (72 Hours)</li>
							<li>UPI Transfer (5 Minutes)</li>
							<li>Digital Gift Vouchers</li>
							<li>Seasonal Bonus Campaigns</li>
						</ul>

						<p>
							Designed to add real value to your professional and personal growth with Hafele.
						</p>
					</div>

					<div className="bottom-space"></div>
				</div>
			</section>
		</>
	);
}